module.exports = "/* .warning-audio-msg{\n    color:red;\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 20px;\n    padding-left: 10px;\n  } */\n\n  .successValidMsgExt{\n    font-family: MuseoSans-500;\n    font-size: 15px;\n    color: #0072BC;\n    line-height: 20px;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/user-status/user-status.component.css
// module id = ./src/app/Screens/user-status/user-status.component.css
// module chunks = main